export const UPDATE_COUNT = 'UPDATE_COUNT';

export const updateCount = count => {
  return {
    type: UPDATE_COUNT,
    count
  }
};